import type { ApiMode } from "@agentry/api-client";

/**
 * 実行時設定。SecretはFrontendへ置かない。
 * ここに入れてよいのはEndpointとModeだけで、API Key/Token/Cookieは扱わない。
 */
export type AppConfig = {
	apiMode: ApiMode;
	apiUrl: string | undefined;
	authUrl: string | undefined;
};

function readEnv(key: string): string | undefined {
	const value = (import.meta.env as Record<string, string | undefined>)[key];
	return value && value.length > 0 ? value : undefined;
}

/**
 * Dev Serverのproxy path。Zerovia側がCORS headerを返さないため、
 * Browserからは同一Originの相対pathで叩くのを既定にする（vite.config.tsのproxyと対）。
 */
const DEFAULT_API_URL = "/zerovia-api";
const DEFAULT_AUTH_URL = "/zerovia-auth";

export function loadConfig(): AppConfig {
	const raw = readEnv("VITE_ZEROVIA_API_MODE");
	// Mockは明示時だけ使用し、未指定・不正値はRealとして接続する。
	const apiMode: ApiMode = raw === "mock" ? "mock" : "real";
	return {
		apiMode,
		apiUrl: readEnv("VITE_ZEROVIA_API_URL") ?? DEFAULT_API_URL,
		authUrl: readEnv("VITE_ZEROVIA_AUTH_URL") ?? DEFAULT_AUTH_URL,
	};
}

/** URLの`?api=mock|real`で一時的に切り替える（POC検証用）。 */
export function applyModeOverride(config: AppConfig, search: string): AppConfig {
	const value = new URLSearchParams(search).get("api");
	if (value !== "mock" && value !== "real") return config;
	return { ...config, apiMode: value };
}
